import { _get, clubId } from "@api/doinsport/services/httpService";

const URI = "/clubs/payment-tokens?club.id="


export const getClubPaymentTokens = () => _get(URI + clubId);
